/**
 * Identity helpers for OpenLayers vector identify / View Info picks.
 * Kept pure so CanvasMapAdapter and tests share one rule for points
 * and polygons (OBJECTID, FID, or the engine feature id).
 */

const ID_KEYS = [
  'OBJECTID_1',
  'OBJECTID',
  'objectid',
  'FID',
  'fid',
  'gid',
  'id',
  'ID',
] as const;

export function isPickedVectorLayerId(layerId: unknown): layerId is string {
  return typeof layerId === 'string' && layerId.length > 0 && !layerId.startsWith('__');
}

export function vectorPickIdFrom(
  featureId: unknown,
  properties: Readonly<Record<string, unknown>> = {},
): string | number | null {
  if (typeof featureId === 'string' && featureId.length > 0) return featureId;
  if (typeof featureId === 'number' && Number.isFinite(featureId)) return featureId;
  for (const key of ID_KEYS) {
    const value = properties[key];
    if (typeof value === 'string' && value.length > 0) return value;
    if (typeof value === 'number' && Number.isFinite(value)) return value;
  }
  return null;
}
